import { createActionGroup, emptyProps, props } from '@ngrx/store';

import {
  Invitation,
  InvitationListQuery,
  InvitationPage,
  InvitationSettings,
  InviteUsersRequest
} from '@core/models/invitation/invitation.model';

export const InvitationsActions = createActionGroup({
  source: 'Invitations',
  events: {
    'Load Page': props<{ query: InvitationListQuery }>(),
    'Reload Page': emptyProps(),
    'Load Page Success': props<{ page: InvitationPage }>(),
    'Load Page Failure': props<{ status?: number }>(),

    'Load Settings': emptyProps(),
    'Load Settings Success': props<{ settings: InvitationSettings }>(),
    'Load Settings Failure': emptyProps(),

    Invite: props<{ request: InviteUsersRequest }>(),
    'Invite Success': props<{ invitations: Invitation[] }>(),
    'Invite Failure': props<{ messages: string[]; named: string[] }>(),
    'Reset Submit State': emptyProps(),

    Cancel: props<{ id: number }>(),
    Extend: props<{ id: number; expirationHours?: number }>(),
    'Row Action Success': props<{ invitation: Invitation }>(),
    'Row Action Failure': emptyProps(),

    'Status Received': props<{ invitation: Invitation }>()
  }
});
